var React = require('react');

function GoldenSection270 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 351.678C0 157.441 157.816 0 352.516 0C547.184 0 705 157.441 705 351.678L705 1055C315.632 1055 0 740.119 0 351.71","fill":"currentColor"}));
}

GoldenSection270.defaultProps = {"width":"705","height":"1055","viewBox":"0 0 705 1055","fill":"none"};

module.exports = GoldenSection270;

GoldenSection270.default = GoldenSection270;
